export const companyDic = "CZ21836256";
